import React from 'react';

const InvalidUrl = () => {
    return (
        <div
            className={'max-w-[1280px] w-full min-h-[100vh] items-center justify-center mx-auto py-[50px] max-md:pt-[10px] px-[14px] flex flex-col gap-[80px] max-md:gap-[40px]'}>
            <div className={'flex justify-center'}>
                <div className={'flex flex-col md:flex-row gap-[25px] items-center'}>
                    <div>
                        <h1 className={'text-[24px] md:text-[36px]'}>Ошибка в URL адресе</h1>
                        <p className={'text-[16px] md:text-[20px]'}>Перейдите по полученной ссылке или свяжитесь с вашим
                            менеджером для предоставления ссылки на презентацию</p>
                    </div>
                    <img src="/img/invalidUrl.svg" alt=""/>
                </div>
            </div>
        </div>
    );
};

export default InvalidUrl;